import { render, staticRenderFns } from "./addBlog.vue?vue&type=template&id=2c781090&scoped=true"
import script from "./addBlog.vue?vue&type=script&lang=js"
export * from "./addBlog.vue?vue&type=script&lang=js"
import style0 from "./addBlog.vue?vue&type=style&index=0&id=2c781090&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c781090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c781090')) {
      api.createRecord('2c781090', component.options)
    } else {
      api.reload('2c781090', component.options)
    }
    module.hot.accept("./addBlog.vue?vue&type=template&id=2c781090&scoped=true", function () {
      api.rerender('2c781090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/addBlog.vue"
export default component.exports